module.exports = __webpack_public_path__ + "img/generic-plugin.3cca4b04.svg";